/**
 * Document actions script file
 *
 * @package    Actions
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import DocumentApi from 'Api/document';

export const DOCUMENT_ITEM_REQUEST = 'DOCUMENT_ITEM_REQUEST';
export const DOCUMENT_ITEM_SUCCESS = 'DOCUMENT_ITEM_SUCCESS';
export const DOCUMENT_ITEM_ERROR = 'DOCUMENT_ITEM_ERROR';

export function loadDocument (data) {
    return function (dispatch) {
        return dispatch({
            request: DocumentApi.loadDocument(data),
            requestType: 'DOCUMENT_ITEM',
        });
    };
}

export function updateDocument (inviteHash, data) {
    return function (dispatch) {
        return dispatch({
            request: DocumentApi.updateDocument(inviteHash, data),
            requestType: 'DOCUMENT_UPDATE',
        });
    };
}
